import React, { useState, useMemo } from 'react';
import { Stack, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from '../../../../../../components/button';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import FlairIcon from '../../../../../../atomic/atoms/FlairIcon';
import { RequestFormFragment } from '../../../../__generated__/graphql';

type RequestFormSelectorProps = {
  requestForms: ReadonlyArray<
    Pick<RequestFormFragment, 'Id' | 'Name' | 'flair__Information__c'>
  >;
  selectedFormId: string | null;
  onFormSelect: (formId: string) => void;
};

export const RequestFormSelector: React.FC<RequestFormSelectorProps> = ({
  requestForms,
  selectedFormId,
  onFormSelect,
}) => {
  const t = useNamespacedTranslation('changeRequests.requestForm');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredForms = useMemo(() => {
    return requestForms.filter((form) =>
      form.Name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [requestForms, searchTerm]);

  return (
    <>
      <div className="ps-3 mb-3 input-group-flush border rounded d-flex gap-3 input-group-merge">
        <InputGroup.Text className="d-flex align-items-center p-0">
          <FlairIcon icon="search-filled-new" />
        </InputGroup.Text>
        <input
          className="list-search form-control"
          type="search"
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          placeholder={t('requestForm.search')}
        />
      </div>

      <Stack gap={2}>
        {filteredForms.map((form) => (
          <OverlayTrigger
            key={form.Id}
            placement="right"
            overlay={
              <Tooltip id={`tooltip-${form.Id}`}>
                {form.flair__Information__c}
              </Tooltip>
            }>
            <div>
              <Button
                label={form.Name}
                variant={
                  selectedFormId === form.Id ? 'primary' : 'outline-primary'
                }
                className="text-start p-3 w-100"
                onClick={(e) => {
                  e.preventDefault();
                  onFormSelect(form.Id);
                }}
              />
            </div>
          </OverlayTrigger>
        ))}
      </Stack>
    </>
  );
};
